import React from "react";
import { Link } from "react-router-dom";
import './CardPedido.css'; // CSS separado para organizar melhor

function formatLeadingZero(text) {
  const n = parseInt(text, 10);
  if (n < 10) return `00${n}`;
  if (n < 100) return `0${n}`;
  return `${n}`;
}

function CardPedido(props) {
  const {
    cor,
    loja,
    foto,
    opcao,
    observacao,
    chapa,
    nome,
    horasol,
    horaeft,
    turno,
    marmitex,
    menu,
    status,
    clickDelete,
  } = props;

  return (
    // No CardPedido.js
    <div className="card-pedido" style={{ backgroundColor: cor || '#fff', borderColor: '#eee' }}>
      <header className="card-pedido-header">
        <div className="card-img-container">
          <img
            className="card-img"
            alt={`Pedido ${chapa}`}
            onClick={props.onFotoClick}
            src={
              foto === null
                ? "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg"
                : `data:image/jpeg;base64,${foto}`
            }
          />
        </div>
        <div className="card-title-group">
          <h4 className="card-nome">
            {opcao === 9 ? observacao : `${nome}`}
          </h4>
          <span className="card-loja">{chapa}<p>Loja: {formatLeadingZero(loja)}</p></span>

        </div>
      </header>

      <section className="card-pedido-body">
        <p><b>Solicitado:</b> {horasol || '--'}</p>
        {status === 1 && (
          <p><b>Atendido:</b> {horaeft || '--'}</p>
        )}
        <p>
          <i className="fas fa-map-marker-alt"></i>{" "}
          {turno !== 0 ? `Turno: ${turno} - ` : ""}
          {marmitex === 0 ? "Restaurante" : "Marmitex"}
        </p>
        {marmitex !== 0 && (
          <p className="card-observacao">
            <b>Menu:</b> {menu}
          </p>
        )}

        {observacao !== "" && (
          <p className="card-observacao">
            {observacao && <><br /><b>Obs:</b> {observacao}</>}
          </p>
        )}


      </section>

      <footer className="card-pedido-footer">
        {status === 1 ? (
          null
        ) : (
          <Link
            to="#"
            onClick={() => clickDelete(chapa, nome)}
            className="btn btn-aguardando"
          >
            <i className="fa fa-spinner fa-spin"></i> Aguardando
          </Link>
        )}
      </footer>
    </div>
  );
}

export default CardPedido;
